module.exports = __webpack_public_path__ + "img/AB5_7418.c027bc38.jpg";